import React, { Component } from 'react';
import {BrowserRouter as Router } from 'react-router-dom'
import LFMapContainer from './Components/LFMapContainer'
import './App.css';
import firebase from 'firebase';



const config = {
      apiKey: "AIzaSyBe3mQkiU3KAGtr17ZwO54UyZidhRdtZqo",
      authDomain: "lost-and-found-pets-143416.firebaseapp.com",
      databaseURL: "https://lost-and-found-pets-143416.firebaseio.com",
      projectId: "lost-and-found-pets-143416",
      storageBucket: "lost-and-found-pets-143416.appspot.com",
      messagingSenderId: "284137841493"
    };


  

  const fbDb = firebase  
  .initializeApp(config)
  .database()
  .ref();

  const fbStorageRef = firebase.storage().ref();
  const geofireRef = firebase.database().ref("geofire");
  // const auth = firebase.auth;

  



class App extends Component {

  componentDidMount = () => {
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        // User is signed in.
        // var isAnonymous = user.isAnonymous;
        // var uid = user.uid;
        // console.log( "user is signed in.  Anonymous = " + isAnonymous + ", uid = " + uid );

        
      } else {
        // User is signed out.
        //console.log( "user is signed out");
      }
      // ...
    });

    firebase.auth().signInAnonymously().catch(function(error) {
      // Handle Errors here.
      // var errorCode = error.code;
      // var errorMessage = error.message;
      // console.log( "auth error code = " + errorCode + ", " + errorMessage );
      // ...
    });
  }


  render() {
    return (
 
      <Router>
      <div className="App"> 
        <LFMapContainer fbDb={fbDb} fbStorageRef={fbStorageRef} geofireRef={geofireRef}/>
      </div>
      </Router>

      
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js